import { useState } from "react";
import { FiFilter, FiSearch, FiShoppingCart, FiTrash2 } from "react-icons/fi";
import { IoIosAddCircle } from "react-icons/io";
import { useDispatch, useSelector } from "react-redux";
import { clearCart, removeFromCart } from "../redux/cartSlice";
import {
  filterCategoryFunc,
  searchDataFunc,
  sortingDataFunc,
} from "../redux/dataSlice";
import { modalFunc } from "../redux/modalSlice";

const Header = () => {
  const dispatch = useDispatch();
  const { items, totalAmount } = useSelector((state) => state.cart);
  const [showCart, setShowCart] = useState(false);

  const categories = [
    "All",
    "Elektronik",
    "Aksesuar",
    "Mobilya",
    "Giyim",
    "Diğer",
  ];

  return (
    <header className="sticky top-0 z-50 w-full bg-[#050404] border-b border-white/5 px-8 py-5 flex items-center justify-between">
      <div className="flex items-center gap-10">
        <div
          className="flex items-center gap-3 cursor-pointer group"
          onClick={() => (window.location.href = "/")}
        >
          <div className="w-10 h-10 bg-[#893168] rounded-md flex items-center justify-center transition-transform group-hover:rotate-6">
            <span className="text-xl font-bold text-white">P</span>
          </div>
          <h1 className="text-2xl font-bold text-white tracking-tight">
            Product<span className="text-[#893168]">Hub</span>
          </h1>
        </div>

        <nav className="hidden lg:flex items-center gap-1">
          {categories.map((cat) => (
            <button
              key={cat}
              onClick={() => dispatch(filterCategoryFunc(cat))}
              className="px-4 py-2 text-sm font-medium text-gray-400 hover:text-white rounded-md transition-colors"
            >
              {cat}
            </button>
          ))}
        </nav>
      </div>

      <div className="flex items-center gap-6">
        <div className="relative group hidden md:block">
          <FiSearch className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-500" />
          <input
            className="bg-[#1a1a1a] border border-white/5 rounded-md pl-10 pr-4 py-2 text-sm text-white outline-none focus:border-[#893168]/50 w-64 transition-all"
            type="text"
            placeholder="Search products..."
            onChange={(e) => dispatch(searchDataFunc(e.target.value))}
          />
        </div>

        <div className="flex items-center gap-3">
          <div className="relative">
            <select
              onChange={(e) => dispatch(sortingDataFunc(e.target.value))}
              className="appearance-none bg-[#1a1a1a] border border-white/5 rounded-md px-4 pr-10 py-2 text-sm text-white outline-none focus:border-[#893168]/50 cursor-pointer h-10"
            >
              <option value="">Sort By</option>
              <option value="asc">Price: Low to High</option>
              <option value="desc">Price: High to Low</option>
            </select>
            <FiFilter className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-500 pointer-events-none" />
          </div>

          <div className="relative">
            <button
              onClick={() => setShowCart(!showCart)}
              className="w-10 h-10 bg-[#1a1a1a] border border-white/5 rounded-md flex items-center justify-center hover:bg-[#2e1c2b] transition-colors relative"
            >
              <FiShoppingCart size={18} className="text-gray-300" />
              {items.length > 0 && (
                <span className="absolute -top-1.5 -right-1.5 w-5 h-5 bg-[#893168] text-white text-[10px] font-bold rounded-full flex items-center justify-center">
                  {items.length}
                </span>
              )}
            </button>

            {showCart && (
              <div className="absolute top-[120%] right-0 w-80 bg-[#2e1c2b] border border-[#893168]/20 p-5 shadow-2xl z-50 rounded-lg">
                <div className="flex items-center justify-between mb-5">
                  <h3 className="font-bold text-white text-lg">My Cart</h3>
                  <button
                    onClick={() => dispatch(clearCart())}
                    className="text-xs text-gray-400 hover:text-white"
                  >
                    Clear All
                  </button>
                </div>

                <div className="max-h-72 overflow-y-auto space-y-4 mb-5">
                  {items.length === 0 ? (
                    <p className="text-center text-gray-500 py-6">
                      Your cart is empty
                    </p>
                  ) : (
                    items.map((item) => (
                      <div key={item.id} className="flex gap-4 group">
                        <img
                          src={item.url}
                          className="w-14 h-14 rounded-md object-cover"
                          alt=""
                        />
                        <div className="flex-1">
                          <p className="text-sm font-semibold text-white line-clamp-1">
                            {item.name}
                          </p>
                          <p className="text-xs text-[#893168] font-bold">
                            {item.quantity} x ${item.price}
                          </p>
                        </div>
                        <button
                          onClick={() => dispatch(removeFromCart(item.id))}
                          className="text-gray-600 hover:text-red-400 transition-colors"
                        >
                          <FiTrash2 size={16} />
                        </button>
                      </div>
                    ))
                  )}
                </div>

                {items.length > 0 && (
                  <div className="pt-4 border-t border-white/5">
                    <div className="flex justify-between items-center mb-5">
                      <span className="text-sm text-gray-400 font-medium">
                        Subtotal
                      </span>
                      <span className="text-xl font-bold text-white">
                        ${totalAmount}
                      </span>
                    </div>
                    <button className="btn-primary w-full py-3 text-sm">
                      Checkout Now
                    </button>
                  </div>
                )}
              </div>
            )}
          </div>

          <button
            onClick={() => dispatch(modalFunc())}
            className="w-10 h-10 bg-[#893168] hover:bg-[#4a1942] rounded-md flex items-center justify-center transition-colors shadow-lg shadow-[#893168]/20"
            title="Add Product"
          >
            <IoIosAddCircle size={22} className="text-white" />
          </button>
        </div>
      </div>
    </header>
  );
};

export default Header;
